import {apolloClient} from '@/setup/apollo-setup';
import {getField, updateField} from "vuex-map-fields";
import * as _ from 'lodash';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';

import {
  ADD_SUBJECTGROUP,
  DELETE_SUBJECTGROUP,
  GET_SUBJECTGROUP,
  GET_SUBJECTGROUPS,
  UPDATE_SUBJECTGROUP,
} from '@/queries/modules/common-data/subjectGroup';

//
// initial state
const state = {
  subjectGroup: {
    id: "",
    degreeId: "",
    facultyId: "",
    code: "",
    nameLocal: "",
    nameEng: "",
  },
  subjectGroups: [],
  searchSubjectGroupResults: [],
  processing: false,
  error: null,
  success: null,
};

//
// getters
const getters = {
  getField
};

//
// mutations
const mutations = {
  updateField,
  clearError: (state) => {
    state.error = null;
  },
  setError: (state, payload) => {
    state.error = payload;
    state.success = null;
    state.processing = false;
  },
  setSuccess: (state, payload) => {
    state.error = null;
    state.success = payload;
    state.processing = false;
  },
  setProcessing: (state, payload) => {
    state.processing = payload;
  },
  setSubjectGroups: (state, payload) => {
    state.subjectGroups = payload ? payload : [];
    state.searchSubjectGroupResults = payload ? payload : [];
  },
  setSubjectGroup: (state, payload) => {
    state.subjectGroup = payload;
  },
  setSelectedSubjectGroup: (state, payload) => {
    state.subjectGroup = {...payload};
  },
  setSearchSubjectGroupResults: (state, payload) => {
    state.searchSubjectGroupResults = payload;
  },
  clearSelectedSubjectGroup: (state) => {
    state.subjectGroup = {
      id: "",
      degreeId: "",
      facultyId: "",
      code: "",
      nameLocal: "",
      nameEng: "",
    }
  }
};

//
// actions
const actions = {
  getSubjectGroups: async ({commit}) => {
    commit('setProcessing', true);

    apolloClient
      .query({
        query: GET_SUBJECTGROUPS,
        context: { clientName: 'Prisma2' }
      })
      .then(({data}) => {
        commit('setSubjectGroups', data.getSubjectGroups);
        commit('setSuccess', null);
      })
      .catch(({err}) => {
        commit('setError', error(err));
      });
  },
  getSubjectGroup: async ({commit}, id) => {
    commit('setProcessing', true);

    apolloClient
      .query({
        query: GET_SUBJECTGROUP,
        variables: {
          id: id
        },
        context: { clientName: 'Prisma2' }
      })
      .then(({data}) => {
        //set Id for relation filed
        let subjectGroup = {
          ...data.getSubjectGroup,
          degreeId: data.getSubjectGroup.degree.id,
          facultyId: data.getSubjectGroup.faculty.id,
        };
        commit('setSubjectGroup', subjectGroup);
        commit('setSuccess', null);
      })
      .catch(({err}) => {
        commit('setError', error(err));
      });
  },
  searchSubjectGroups: async ({commit}, payload) => {
    commit('setProcessing', true);

    try {
      commit('setSearchSubjectGroupResults', _.filter(state.subjectGroups, (subjectGroup) => _.some(subjectGroup, value => _.includes(_.toLower(value), _.toLower(payload)))));
      commit('setProcessing', false);
    } catch (err) {
      commit('setError', error(err));
    }
  },
  addSubjectGroup: async ({commit}, payload) => {
    commit('setProcessing', true);

    await apolloClient
      .mutate({
        mutation: ADD_SUBJECTGROUP,
        variables: payload,
        context: { clientName: 'Prisma2' }
      })
      .then(({data}) => {
        const subjectGroups = [...state.subjectGroups];
        subjectGroups.push(data.addSubjectGroup);
        commit('setSubjectGroups', subjectGroups);
        commit('setSuccess', newItemSuccess(data.addSubjectGroup.nameLocal));
      })
      .catch((err) => {
        commit('setError', error(err));
      });
  },
  updateSubjectGroup: async ({commit}, payload) => {
    commit('setProcessing', true);

    apolloClient
      .mutate({
        mutation: UPDATE_SUBJECTGROUP,
        variables: payload,
        context: { clientName: 'Prisma2' }
      })
      .then(({data}) => {
        const index = state.subjectGroups.findIndex(subjectGroup => subjectGroup.id === data.updateSubjectGroup.id);
        const subjectGroups = [
          ...state.subjectGroups.slice(0, index),
          data.updateSubjectGroup,
          ...state.subjectGroups.slice(index + 1)
        ];

        commit('setSubjectGroups', subjectGroups);
        commit('setSuccess', updateItemSuccess(data.updateSubjectGroup.nameLocal));
      })
      .catch(({err}) => {
        commit('setError', error(err));
      });
  },
  deleteSubjectGroup: async ({commit}, payload) => {
    commit('setProcessing', true);

    apolloClient
      .mutate({
        mutation: DELETE_SUBJECTGROUP,
        variables: payload,
        context: { clientName: 'Prisma2' }
      })
      .then(({data}) => {
        const index = state.subjectGroups.findIndex(subjectGroup => subjectGroup.id === data.deleteSubjectGroup.id);
        const subjectGroups = [
          ...state.subjectGroups.slice(0, index),
          ...state.subjectGroups.slice(index + 1)
        ];

        commit('setSubjectGroups', subjectGroups);
        commit('setSuccess', deleteItemSuccess(data.deleteSubjectGroup.nameLocal));
      })
      .catch(({err}) => {
        commit('setError', error(err));
      });
  },
  selectedSubjectGroup: async ({commit}, payload) => {
    commit('setSelectedSubjectGroup', payload);
  },
  clearSelectedSubjectGroup: async ({commit}) => {
    commit('clearSelectedSubjectGroup');
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
